export default __webpack_public_path__ + "static/media/pen.a086f758.svg";